@if (initialized && contract) {

  <div class="grid">
    <div class="col-12">
      <div class="surface-card lg:p-3 p-2 shadow-2 border-round">
        @if (contract.autopilotAvailable) {
          @if (contract.autopilotActive) {
            <i class="pi pi-heart-fill text-primary text-5xl mb-3"></i>
          } @else {
            <div class="flex flex-column align-items-center justify-content-center mb-3">
              <i class="pi pi-heart text-primary text-5xl"></i>
              <span class="text-sm text-light text-primary mt-2">Autopiloten aktivieren</span>
            </div>
          }
        }
        <div class="flex gap-3 align-items-center flex-column lg:flex-row lg:justify-content-between my-2">
          <div class="flex gap-3 align-items-center flex-column md:flex-row">

            <div
              class="w-6 sm:w-12rem xl:w-10rem block xl:block mx-auto border-round border-round border-1 border-100 p-3">
              @if (contract.insuranceCompany?.imageUrl) {
                <img class="max-w-full h-auto" style="object-fit: contain;"
                     [src]="contract.insuranceCompany?.imageUrl" [alt]="contract.insuranceCompany?.name"/>
              } @else {
                @if (contract.insuranceCompany?.shortName) {
                  {{ contract.insuranceCompany?.shortName }}
                } @else {
                  {{ contract.insuranceCompany?.name }}
                }
              }
            </div>

            <div class="flex mt-2 flex-column align-items-center md:align-items-start w-max">
              <span class="text-color font-medium text-2xl">
                @if (contract.insuranceType) {
                  {{ contract.insuranceType.name }}
                }
              </span>
              <div class="text-color-secondary text-xl font-medium mb-3 mt-2">{{ contract.insuranceIdentNumber }}</div>
            </div>
          </div>

        </div>

        <ul class="list-none p-0 m-0 border-top-1 border-300">

          @if (contract.notFullyManaged) {

            <p-messages severity="error">
              <ng-template pTemplate>
                <div class="w-full flex justify-content-between align-items-center">
                  <div class="flex gap-3 align-items-center">
                    <i class="pi pi-exclamation-triangle text-2xl"></i>
                    <div class="flex flex-column gap-1">
                      <span>
                        <p class="font-bold">Wichtige Information zu diesem Vertrag</p>
                        Dieser Vertrag kann leider nicht von uns betreut werden, da die Versicherungsgesellschaft ausschließlich mit eigenen Beratern zusammenarbeitet und keine Makler wie uns einbindet.
                      </span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-messages>

            <p-messages severity="success">
              <ng-template pTemplate>
                <div class="w-full flex justify-content-between align-items-center">
                  <div class="flex gap-3 align-items-center">
                    <i class="pi pi-info-circle text-2xl"></i>
                    <div class="flex flex-column gap-1">
                      <span>
                        <p class="font-bold">Gute Nachrichten: Wir können es besser machen!</p>
                        <p>Unsere Erfahrung zeigt, dass wir 9 von 10 dieser Verträge verbessern können – mit besseren Leistungen und teilweise deutlich günstigeren Konditionen.</p>
                        <p>Bereits über 25.000 Kunden haben von unserer Expertise profitiert und ihre Verträge erfolgreich optimiert. Das Ergebnis? Bessere Absicherung, mehr Leistung und oft geringere Kosten.</p>
                        <p>Unsere Kunden sind begeistert: Mit über 1.000 exzellenten Bewertungen auf Google und ProvenExpert und einer Durchschnittsbewertung von 4,9 Sternen bestätigen sie unsere hohe Servicequalität.</p>
                        <p>Lass uns gemeinsam prüfen, ob für dich auch eine bessere Lösung möglich ist!</p>
                      </span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-messages>

          }



          <li class="flex align-items-center py-3 px-2 flex-wrap surface-ground lg:gap-0 gap-3">
            <div class="text-500 w-full lg:w-3 font-medium">Versicherungsnummer</div>
            <div class="text-900 w-full lg:w-9">{{ contract.insuranceIdentNumber }}</div>
          </li>
          <li class="flex align-items-center py-3 px-2 flex-wrap lg:gap-0 gap-3">
            <div class="text-500 w-full lg:w-3 font-medium">Beitrag</div>
            <div class="text-900 w-full lg:w-9 line-height-3">


              @if (contract?.freePayment) {
                Beitragsfrei
              } @else if (contract.costInfoExist) {
                {{ contract.cost.formattedAmount }}
              } @else {
                -
              }

            </div>
          </li>
          <li class="flex align-items-center py-3 px-2 flex-wrap surface-ground lg:gap-0 gap-3">
            <div class="text-500 w-full lg:w-3 font-medium">Zahlfrequenz</div>
            <div class="text-900 w-full lg:w-9">
              @if (contract.costInfoExist) {
                {{ contract.paymentFrequencyText }}
              } @else {
                -
              }

            </div>
          </li>
          <li class="flex align-items-center py-3 px-2 flex-wrap lg:gap-0 gap-3">
            <div class="text-500 w-full lg:w-3 font-medium">Vertragszustand</div>
            <div class="text-900 w-full lg:w-9">
              @if (!contract.notFullyManaged) {

                @if (contract.contractStatus == 0) {
                  <p-tag styleClass="px-2" severity="success" icon="pi pi-circle-fill pr-1"
                         [value]="contract.contractStatusText" [rounded]="true"></p-tag>
                } @else if (contract.contractStatus == 1) {
                  <p-tag styleClass="px-2" severity="danger" icon="pi pi-circle-fill pr-1"
                         [value]="contract.contractStatusText" [rounded]="true"></p-tag>
                } @else if (contract.contractStatus == 2) {
                  <p-tag styleClass="px-2" severity="warning" icon="pi pi-circle-fill pr-1"
                         [value]="contract.contractStatusText" [rounded]="true"></p-tag>
                }
              } @else {
                <p-tag styleClass="px-2" severity="danger" icon="pi pi-circle-fill pr-1"
                       [value]="'Keine Informationen von Gesellschaft erhalten'" [rounded]="true"></p-tag>

              }

            </div>
          </li>
          <li class="flex align-items-center py-3 px-2 flex-wrap surface-ground lg:gap-0 gap-3">
            <div class="text-500 w-full lg:w-3 font-medium">Beginn</div>
            <!--            Ticket DWK1000000764-->
            @if (contract?.startDate && contract?.startDate !== '1900-01-01') {
              <div class="text-900 w-full lg:w-9">{{ contract.startDate | date:"dd.MM.YYYY" }}</div>
            } @else {
              -
            }
          </li>

          <li class="flex align-items-center py-3 px-2 flex-wrap surface-ground lg:gap-0 gap-3"
              *ngIf="contract.contractStatus == 1">
            <div class="text-500 w-full lg:w-3 font-medium">Ende</div>
            @if (contract?.endDate && contract?.endDate !== '1900-01-01') {
              <div class="text-900 w-full lg:w-9">{{ contract.endDate | date:"dd.MM.YYYY" }}</div>
            } @else {
              -
            }
          </li>

          <li class="flex align-items-center py-3 px-2 flex-wrap lg:gap-0 gap-3">
            <div class="text-500 w-full lg:w-3 font-medium">Gesellschaft</div>
            <div class="text-900 w-full lg:w-9">
              @if (contract.insuranceCompany?.shortName) {
                {{ contract.insuranceCompany?.shortName }}
              } @else {
                {{ contract.insuranceCompany?.name }}
              }
            </div>
          </li>

        </ul>
      </div>
    </div>

    @if (contract.insurableObjects && contract.insurableObjects.length > 0) {
      @if (contract.notifications && contract.notifications.length > 0) {
        <div class="col-12 lg:col-6">
          <app-insurable-objects [insurableObjects]="contract.insurableObjects"
                                 [showContractCount]="false"></app-insurable-objects>
        </div>
      } @else {
        <div class="col-12">
          <app-insurable-objects [insurableObjects]="contract.insurableObjects"
                                 [showContractCount]="false"></app-insurable-objects>
        </div>
      }


    }


    @if (contract.notifications && contract.notifications.length > 0) {
      @if (contract.insurableObjects && contract.insurableObjects.length > 0) {
        <div class="col-12 lg:col-6">
          <app-notifications [notifications]="contract.notifications"></app-notifications>
        </div>
      } @else {
        <div class="col-12">
          <app-notifications [notifications]="contract.notifications"></app-notifications>
        </div>
      }


    }


    @if (contract.documents) {
      <div class="col-12 card">
        <div class="text-color text-2xl w-full font-medium mb-3">Dokumente</div>
        <div class="text-900 w-full">
          <div class="grid mt-0 mr-0">
            @if (contract.documents.length) {
              @for (document of contract.documents; track document.id) {
                <div class="col-6 md:col-4 lg:col-3 xl:col-2">
                  <div class="p-2 border-1 surface-border border-round surface-card text-sm">
                    <div class="mb-2 flex justify-content-between align-items-center">
                      <i class="pi"
                         [ngClass]="document.mimeType == 'application/pdf' ? 'pi-file-pdf' : 'pi-image'"></i>
                      <i [pTooltip]="'View'" tooltipPosition="top" class="pi pi-eye cursor-pointer"
                         (click)="downloadDocument(document)"></i>
                    </div>
                    <div class="font-medium text-ellipsis overflow-hidden whitespace-nowrap">
                      {{ document.name }}
                    </div>
                    <div class="text-600 text-xs mt-1">{{ document.additionalInformation }}</div>
                    <div class="flex justify-content-between mt-2 text-500 text-xs">
                      <span>{{ document.mimeType | mimeTypePipe }}</span>
                      <span>{{ document.uploadedOn | date:'dd.MM.yyyy' }}</span>
                    </div>
                  </div>
                </div>
              }
            } @else {
              <span class="text-600 px-3">N/A</span>
            }
          </div>
        </div>
      </div>
    }

  </div>


  <p-dialog
    header="Dokument"
    *ngIf="showDocumentVisible"
    [(visible)]="showDocumentVisible"
    [style]="{width: '65rem', height: '75vh'}"
    [modal]="true"
    (onHide)="showDocumentId = undefined"
  >
    @if (showDocumentId) {
      <app-pdf-view [objectService]="contractApiService"
                    [documentId]="showDocumentId"
                    [addedId]="contractId"
                    (handleNewWindowOpened)="handleWindowOpened($event)"
                    class="w-full h-full">
      </app-pdf-view>
    }

  </p-dialog>

}


